import React from 'react';
import {MasterLayout} from 'layout';
import {TinhHinhXuLyDonTaiDonVi} from 'modules/theo-doi-giam-sat';

export default class TinhHinhXuLyDonTaiDonViPage extends React.Component {
 
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TinhHinhXuLyDonTaiDonVi id={this.props.params.id}/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-giam-sat/TinhHinhXuLyDonTaiDonViPage.jsx